import React, { useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

import {
    Layout,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    DatePicker,
    Col,
    Table,
    Divider,
    Button,
    Modal,
    Popconfirm,
} from "antd";
import TextArea from 'antd/es/input/TextArea';
import { BOM } from "../../../../../../services/definedMethod";
import { labelConfig } from "../../../../customer.config";


const { Text } = Typography

const Collateral = (props) => {

    const { loanCollateralOptions, 
        collateralFormData, 
        setCollateralFormData, 
        collateralTableSource, 
        setCollateralTableSource, 
        collateralTableCount, 
        setCollateralTableCount,
        handleSave } = props;

        

        const handleCollateralDelete = (key) => {
            const newData = collateralTableSource.filter((item) => item.key !== key);
            setCollateralTableSource(newData);
        };

    const defaultCollateralColumns = [

        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Value",
            dataIndex: "value",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                collateralTableSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleCollateralDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: "#92428B",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CloseOutlined
                            style={{
                                color: "#92428B",
                                fontSize: "15px",
                                fontWeight: "bolder",
                            }}
                        />
                    </Popconfirm>
                ) : null,
        },
    ];


    
    const handleCollateralAdd = (formValues) => {
        console.log(collateralFormData)

        const newData = {
            key: collateralTableCount,
            id: collateralTableCount,
            type: collateralFormData.collateralId,
            value: collateralFormData.collateralValue,
            description: collateralFormData.description,
        };
        setCollateralTableSource([...collateralTableSource, newData]);

        setCollateralTableCount(collateralTableCount + 1);
    };

        const collateralColumns = defaultCollateralColumns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    // handleSave,
                }),
            };
        });


    return (
        <>

<Col span={24} style={{ padding: "0px 8px" }}>
    <Row style={{ justifyContent: "space-between", marginTop: 20 }}>
        <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
                label={labelConfig.collateral}
                name="collateralId"
                rules={[
                    {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.collateral),
                    },
                ]}
            >
                <Select
                    placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.collateral}`,
                        "select"
                    )}
                    showSearch
                    options={loanCollateralOptions}
                // onChange={onCollateralChange}

                />
            </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>

            <Form.Item
                label={<Text >{labelConfig.value}</Text>}
                name="collateralValue"

            >
                <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.value)}

                />
            </Form.Item>
        </Col>

        <Col span={8}>
            <div></div>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>

            <Form.Item
                label={<Text strong hidden>{labelConfig.collateral}</Text>}
                name="description"
            >
                <TextArea
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.description)}
                    style={{
                        width: "100%"
                    }}
                />
            </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>

            <Form.Item>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    shape='round'
                    style={{
                        backgroundColor: "#92428B",
                        color: "white",
                        width: "15vh",
                        marginTop: 30,
                    }}
                    onClick={handleCollateralAdd}
                >
                    Add
                </Button>
            </Form.Item>
        </Col>

        <Col span={8}>
            <div></div>
        </Col>
    </Row>
    <Table
        columns={collateralColumns}
        dataSource={collateralTableSource}
    >
    </Table>
</Col>
        </>
    )
}

export default Collateral